import { combineReducers } from 'redux'
import drawables from "./drawables";
import others from "./others";

export default combineReducers({
  drawables,
  others
})